import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatTabsModule } from '@angular/material/tabs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppHttpService } from './shared/services/app-http/app-http.service';
import { AuthService } from './shared/services/auth/auth.service';
import { HelperService } from './shared/services/helper.service';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { UserAccessInterceptor } from './shared/interceptor/user-access.interceptor';
import { PublicAccessInterceptor } from './shared/interceptor/public-access.interceptor';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    MatTabsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(), // ToastrModule added
  ],
  providers: [
    AuthService,
    AppHttpService,
    HelperService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: UserAccessInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PublicAccessInterceptor, multi: true },
  ],
  exports: [MatTabsModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
